import React, { useState } from "react";
import "./LogsPage.css";

import EmailLogs from "../Emails/EmailsLogs";
import ApplicationLogs from "./ApplicationLogs";
import SessionManagement from "../../adminrh/Sessions/SessionManagement";

const LogsPage = () => {
    const [activeTab, setActiveTab] = useState("APP");

    return (
        <div className="logs-page">
            <div className="logs-page-header">
                <div>
                    <h2>Historique & journaux</h2>
                    <p>Consultez les logs applicatifs et les logs des emails envoyés.</p>
                </div>
            </div>

            <div className="logs-tabs">
                <button
                    className={`logs-tab ${activeTab === "APP" ? "active" : ""}`}
                    onClick={() => setActiveTab("APP")}
                >
                    Logs applicatifs
                </button>

                <button
                    className={`logs-tab ${activeTab === "EMAIL" ? "active" : ""}`}
                    onClick={() => setActiveTab("EMAIL")}
                >
                    Logs des emails
                </button>

                <button
                    className={`logs-tab ${activeTab === "SESSION" ? "active" : ""}`}
                    onClick={() => setActiveTab("SESSION")}
                >
                    Logs des sessions
                </button>
            </div>

            <div className="logs-tab-content">
                {activeTab === "APP" && <ApplicationLogs />}
                {activeTab === "EMAIL" && <EmailLogs />}
                {activeTab === "SESSION" && <SessionManagement />}
            </div>
        </div>
    );
};

export default LogsPage;
